module.exports = __webpack_public_path__ + "83612372.svg";